/* eslint-disable no-undef */
// userSaga.js
import { call,  put,  takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { Modal } from 'antd';
import { createProfileRequestError, createProfileRequestSuccess, createUserRequestError, createUserRequestSuccess } from './Actions';
import { CREATE_PROFILE_REQUEST, CREATE_USER_REQUEST } from './Constants';
// import { Modal } from 'antd';
import { jwtDecode as jwt_decode } from 'jwt-decode';
import capitalizeWords from '../../Helper/capitaise';
import dayjs from 'dayjs';


function* createUser(action) {

    try {    

        const registerValue = action.payload;
        const url = `${process.env.REACT_APP_API_BASE_URL}/users`;

        const headers ={
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
        

        let data = {
            email: registerValue.email,
            cellphone: registerValue.cellphone,
            password: registerValue.password,
            permissions: 'patient',
            usertypeId: 5,
            countryCode: registerValue.countryCode,
        };        
        
        const response = yield call(axios.post, url, data, { headers});
        
        if(response.status === 200 || response.status === 201) {

            const loginUrl = `${process.env.REACT_APP_API_BASE_URL}/authentication`;

            let data = {
                strategy: 'local',
                email: registerValue.email,
                password: registerValue.password,
            };

            const headers = {
                'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
                'Content-Type': 'application/json',
                'x-api-version': process.env.REACT_APP_X_API_VERSION,
            };
            
            const loginResponse = yield call(axios.post, loginUrl, data, { headers});

            let decode;

            if(loginResponse.status === 201 || loginResponse.status === 200) {
                
                sessionStorage.setItem('jwt', loginResponse.data.accessToken);
                decode = jwt_decode(loginResponse.data.accessToken);
                localStorage.setItem('NEWUSER_ID', decode.userId);
                sessionStorage.setItem('USER_ID', decode.userId);
                yield put(createUserRequestSuccess('success'));
            }

        } else {
            // Modal.error({
            //     title: 'Registration failed',
            //     content:
            //       'Your Email ID or Phone number is already associated with QuikDr Network. Please login using your email id and password associate with QuikDr. If You forgot password, please use forgot password option.',
            // });
            yield put(createUserRequestError('An error occurred.'));
        }
                       
    } catch (error) {        
        Modal.error({
            title: 'Registration failed',
            content:
              'Your Email ID or Phone number is already associated with QuikDr Network. Please login using your email id and password associate with QuikDr. If You forgot password, please use forgot password option.',
        });
        yield put(createUserRequestError('An error occurred.'));
    }

}

function* createProfile(action) {

    try {    

        const prolileUploadDetails = action.payload;

        let isint;
        if (prolileUploadDetails.residentCountry === 'India') {
            isint = false;
        } else {
            isint = true;
        }

        const urll = `${process.env.REACT_APP_API_BASE_URL}/users?id=${localStorage.getItem('NEWUSER_ID')}`;

        
        const headers ={
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
        
        const responseUsers = yield call(axios.get, urll, { headers});

        let dataa;
        if (responseUsers.status === 200 || responseUsers.status === 201) {
            dataa = responseUsers.data;
            
            let data = {
                usersId: dataa.data[0].id,
                primaryEmail: dataa.data[0].email,
                primaryContact: dataa.data[0].cellphone,
                isInternational: isint,
                firstName: capitalizeWords(
                    prolileUploadDetails.firstName
                ),
                lastName: capitalizeWords(
                    prolileUploadDetails.lastName
                ),
                address: prolileUploadDetails.address,
                bloodGroup: prolileUploadDetails.bloodGroup,
                gender: prolileUploadDetails.gender,
                initials: prolileUploadDetails.initials,
                nationality: prolileUploadDetails.Country,
                latitude: '+21.2412',
                longitude: '+12.2236',
                residentCountry: prolileUploadDetails.residentCountry,
                district: prolileUploadDetails.district,
                state: prolileUploadDetails.state,
                lsg: prolileUploadDetails.localBodyValue,
                relationShip: '',
                countryCode: prolileUploadDetails.countryCode,
                isParent: true,
                parentId: dataa.data[0].id,
                secondaryContact: prolileUploadDetails.secondaryContact,
                dob: dayjs(prolileUploadDetails.dateOfBirth).format('YYYY-MM-DD')
            };

            const url = `${process.env.REACT_APP_API_BASE_URL}/patients`;
            
            const response = yield call(axios.post, url, data, { headers});

            if(response.status === 200 || response.status === 201){
                sessionStorage.setItem('PATIENT_ID', response.data.id);
                localStorage.setItem('PATIENT_IDS', response.data.id);
                localStorage.setItem('FAMILY_PATIENT_ID', response.data.id);
                localStorage.setItem('PARENT_PATIENT_ID', response.data.id);
                localStorage.setItem('PARENT_USERID', response.data.usersId);
                localStorage.setItem('PARENT_EMAIL', response.data.primaryEmail);
                localStorage.setItem('PARENT_PHONE', response.data.primaryContact);
                localStorage.setItem('PARENT_PATIENT_ID', response.data.id);
                sessionStorage.setItem('USER_ID', response.data.usersId);
                localStorage.setItem('REQ_PATIENT_ID', response.data.id);

                Modal.success({
                    title: 'Registration Completed!',
                    content: 'Registration Completed successfully.',
                });
                yield put(createProfileRequestSuccess(response.data));
            } else {
                Modal.error({
                    title: 'Request Failed.',
                    content: 'Request failed due to some technical issue',
                });
                yield put(createProfileRequestError('An error occurred.'));
            }
        } else {
            Modal.error({
                title: 'Request Failed.',
                content: 'Request failed due to some technical issue',
            });
            yield put(createProfileRequestError('An error occurred.'));
        }                       
    } catch (error) {        
        Modal.error({
            title: 'Request Failed.',
            content: 'Request failed due to some technical issue',
        });
        yield put(createProfileRequestError('An error occurred.'));
    }

}

// Watcher Saga
export function* watchFetchRegister() {
    yield takeEvery(CREATE_USER_REQUEST, createUser);
    yield takeEvery(CREATE_PROFILE_REQUEST, createProfile);

}
